import { Grid } from "@mui/material";

import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import type { ISearchDto } from "@dzambalaorg/types-collection";
import { TextInput } from "@dzambalaorg/mui-inputs-core";

export interface IReferralTreeSearchDto extends ISearchDto {
  referral: string;
  wallet: string;
  level: number;
  merchantIds: Array<number>;
}

export const ReferralTreeSearchForm = () => {
  return (
    <SearchWithFilters>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 6 }}>
          <TextInput name="wallet" normalizeValue={(value: string | undefined) => value ?? ""} />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <TextInput name="referral" normalizeValue={(value: string | undefined) => value ?? ""} />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
